
import {debounce} from "lodash-es";
import {defineComponent, onBeforeUnmount, onMounted, ref} from "vue";
import {CountTo} from "vue3-count-to";

export default defineComponent({
  props: {
    value: String,
    suffix: String,
    prefix: String,
  },
  components: {
    CountTo
  },
  setup() {
    let isAnimated = ref(false), windowHeight = 0, decimals = ref(0)
    const root = ref<HTMLDivElement>()

    const setParams = () => {
      windowHeight = window.innerHeight
    }
    const parseValue = (value: String) => {
      if (value.match(/[^$,.\d]/)) {
        return Number(value.replace(/\D/g, ''))
      }
      let decimalString = value.split(".")[1];
      decimals.value = decimalString ? decimalString.length : 0;
      return Number(value)
    }

    const parsePrefix = (prefix: String) => {
      if (prefix) {
        return prefix + ' ';
      }
    }
    const handleScroll = () => {
      const elOffsetTop = root.value ? root.value.getBoundingClientRect().top : 0
      if (!isAnimated.value && (windowHeight * 0.95 > Math.abs(elOffsetTop))) {
        isAnimated.value = true
      }
    }

    onMounted(() => {
      setParams();
      handleScroll();
      window.addEventListener('resize', debounce(setParams, 250))
      window.addEventListener('scroll', debounce(handleScroll, 100))
    })
    onBeforeUnmount(() => {
      window.removeEventListener('resize', debounce(setParams, 250));
      window.removeEventListener('scroll', debounce(handleScroll, 100));
    })

    return {
      isAnimated, parseValue, root, decimals, parsePrefix
    }
  }
})
